export type QuizLocation = 'selected' | 'review' | 'checkup' | 'block' | 'applied' | 'explanation' | 'wrapup' | 'post'

export const QUIZ_LOCATIONS: { value: QuizLocation; label: string; color: string }[] = [
  { value: 'selected', label: '진도', color: 'bg-blue-100 text-blue-700' },
  { value: 'review', label: '복습', color: 'bg-green-100 text-green-700' },
  { value: 'checkup', label: '체크업', color: 'bg-teal-100 text-teal-700' },
  { value: 'block', label: '블록퀴즈', color: 'bg-purple-100 text-purple-700' },
  { value: 'applied', label: '실전연습', color: 'bg-amber-100 text-amber-700' },
  { value: 'explanation', label: '설명하기', color: 'bg-rose-100 text-rose-700' },
  { value: 'wrapup', label: '성인', color: 'bg-slate-100 text-slate-700' },
  // 레거시에서 위치 분류가 안 된 문제(isa 링크만 있는 문제). 허브(quiz-mgt)가 등록한 미발행 문제도 여기로 들어온다.
  { value: 'post', label: '미분류(post)', color: 'bg-zinc-100 text-zinc-700' },
]

const LABELS: Record<string, string> = {
  ...Object.fromEntries(QUIZ_LOCATIONS.map(location => [location.value, location.label])),
  pre: '사전(pre)',
}

/** content_quiz_mapping.quiz_location 값을 검수 화면 라벨로 바꾼다. 모르는 값은 그대로 보여 준다. */
export function quizLocationLabel(location: string): string {
  return LABELS[location] ?? location
}
